import { createFileRoute } from "@tanstack/react-router";
import AdminSetQuestionsPage from "@/pages/admin/sets/detail/questions";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/questions/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId } = Route.useParams();
  const { userCanEditAllSets, userCanViewAllSets, userCanViewAllPrograms, userCanViewAllCriteria } = useSetsPermissions();

  return (
    <AdminSetQuestionsPage
      setId={Number(setId)}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllPrograms={userCanViewAllPrograms}
      userCanViewAllCriteria={userCanViewAllCriteria}
    />
  );
}
